/**
 * Copilot demo-gating flags (#117).
 *
 * Single source of truth for marking the Copilot "Coming soon" across the
 * launcher, the right-side panel, the shared chat surface, and the
 * full-page `/app/twin/copilot` route.
 *
 * While `COPILOT_COMING_SOON` is `true`:
 *   - the launcher + panel + page show a "Coming soon" badge / state, and
 *   - the chat input + send button are disabled so the demo copilot can't
 *     be driven.
 *
 * Nothing is deleted — flip this back to `false` to fully re-enable the
 * copilot. Kept as a plain `boolean` so the gated/un-gated branches both
 * type-check (no literal narrowing).
 */
export const COPILOT_COMING_SOON: boolean = true;

/** Short pill label reused wherever the "Coming soon" badge is rendered. */
export const COPILOT_COMING_SOON_LABEL = "Coming soon";
